<template>
  <div id = 'wholePortfolio' class = 'text-left animated fadeIn'>
    <!-- <h1 id = 'headline' class = 'p-3 ml-5'>
      <strong>
        {{ msg }}
      </strong>
    </h1> -->

    <!-- <hr style = 'border-color: #ff6b6b'/> -->

    <div id = 'portfolio' class = 'mx-3 p-4'>

      <p class = 'p-3' style = 'font-size: 20px;'>
        <strong>
          Click on a project title to learn more!
        </strong>
      </p>
      
      <div class = 'row px-5'>
        <br />

        <div 
          v-for = '(item, index) in portfolioItems'
          v-bind:key = index
          v-bind:title = item.title
          class = 'col-xs-6 col-sm-4 animated fadeIn sloDown'
        > 
          <a v-on:click = 'urlMaker(index, $event)'>
            <div class = 'wrapper py-4'>
            <img v-bind:src = 'item.img' class = 'portfolioImg rounded'/>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/globals'
import $ from 'jquery'
import portfolioItems from '@/assets/portfolioItems'

export default {
  name: 'Portfolio',
  mounted () {
    store.commit('menu')
  },
  updated () {
    store.commit('menu')
  },
  data () {
    return {
      msg: 'Portfolio',
      portfolioItems: portfolioItems
    }
  },
  methods:{
    urlMaker: function(index, event) {
      $('#wholePortfolio').addClass('animated fadeOut')
      const newUrl= "/portfolio/" + index
      
      setTimeout ( function () {
        console.log('change!')
        window.location.hash = newUrl
      },1000)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
hr {
  border-color: #ff6b6b;
}

h1 {
  color: #4ecdc4;
}

h1:hover {
  color: #ff6b6b;
}

a:link{
  color: white;
}
a:visited{
  color: orange;
}
a:active{
  color: yellow;
}
a:hover{
  color: orangered
}

.sloDown{
    -webkit-animation-duration: 3s;
    -moz-animation-duration: 3s;
    -ms-transition-animation-duration: 3s;
}

.wrapper {
  width: 100%;
  min-width: 100%;
  max-height: 200px;
  overflow: hidden;
}

#portfolio {
  background-color: #f6f7eb;
  color: #292f36;
}

#wholePortfolio {
  background-color: #292f36;
  color: #f6f7eb;
  min-height: 100%;
}
@media screen and (max-width: 768px){
  .portfolioImg {
    object-fit: fill;
    width: 200px;
    height: auto;
  }
}
@media screen and (min-width: 768px){
  .portfolioImg {
    object-fit: fill;
    width: 600px;
    height: auto;
  }
}
@media screen and (min-width: 992px){
  .portfolioImg {
    object-fit: fill;
    width: 600px;
    height: auto;
  }
  #portfolio {
    min-height: 750px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Portfolio.vue